import http from "@/shared/services/http";

export const createProvinceV21 = (data: any) => http.post(`v1/regions/provinces/create`, data);
export const singleProvinceV21 = (id: number) => http.get(`v1/regions/provinces/single/${id}`);
export const editProvinceV21 = (data: any) => http.put(`v1/regions/provinces/edit/${data.id}`, data);
export const listProvinceV21 = (params: any = {}) => http.get(`v1/regions/provinces/list`, { params });
export const deleteProvinceV21 = (id: number) => http.delete(`v1/regions/provinces/delete/${id}`);
